<template>
  <div class="bt-transaksi pb-5 mb-5">
    <div class="d-flex align-center">
      <v-container class="d-flex flex-column align-center justify-center fill-height">
        <v-row>
          <v-col cols="12">
            <div class="text-center">
              <img src="@/assets/logo.png" alt="" contain height="80" class="mx-auto" />
              <h2 class="white--text font-weight-bold">Selamat datang di LHP</h2>
              <p class="white--text">Mencatat laporan harian petugas dari transaksi penagihan, penilaian, dan laporan.</p>
            </div>
            <p class="text-caption px-4 py-2 mx-4 my-2 rounded-lg text-justify d-flex align-center" style="background-color: #ffe6c9; color: #ff7d29">
              <v-icon class="mr-4" small color="#FF7D29">mdi-information</v-icon> Sistem ini memerlukan ijin dari user untuk menggunakan CAMERA dan GPS. Ketika ada permintaan perizinan, silahkan setujui.
            </p>
          </v-col>
        </v-row>
        <v-row style="width: 100%">
          <v-col cols="6">
            <v-card class="account-card active">
              <v-card-text class="text-center">
                <router-link to="/penagihan/dashboard">
                  <img src="@/assets/icon/anggota_in.png" alt="" contain height="50" class="mx-auto" />
                  <h4>Penagihan</h4>
                  <p></p>
                </router-link>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card class="account-card">
              <v-card-text class="text-center">
                <router-link to="/penilaian/dashboard">
                  <img src="@/assets/icon/penilaian.png" alt="" contain height="50" class="mx-auto" />
                  <h4>Penilaian</h4>
                  <p></p>
                </router-link>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card class="account-card">
              <v-card-text class="text-center">
                <router-link to="/laporan">
                  <img src="@/assets/icon/laporan.png" alt="" contain height="50" class="mx-auto" />
                  <h4>Laporan</h4>
                  <p></p>
                </router-link>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lhp",
};
</script>
<style scoped>
.v-container {
  background: linear-gradient(to bottom right, #7f4acb, #b25ec7);
  height: 100vh;
}

.account-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 16px;
  transition: all 0.3s;
}

.account-card h4 {
  color: white;
}

.account-card:hover {
  background: rgb(255, 255, 255, 0.8);
}

.account-card:hover h4 {
  color: #672178;
}

.active {
  background: rgb(255, 255, 255, 0.8);
}
.active h4 {
  color: #672178;
}
</style>
